import { render, staticRenderFns } from "./HtmlEditorVariables.vue?vue&type=template&id=1be53585&scoped=true"
import script from "./HtmlEditorVariables.vue?vue&type=script&lang=js"
export * from "./HtmlEditorVariables.vue?vue&type=script&lang=js"
import style0 from "./HtmlEditorVariables.vue?vue&type=style&index=0&id=1be53585&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be53585",
  null
  
)

export default component.exports